import React from 'react'
import HighLighter from "react-highlight-words"

const reg = (str) => str.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&')

const Highlighter = ({ searchWords, ...rest }) => {
  const regSearchWords = searchWords.map(word => reg(word))
  return <HighLighter searchWords={regSearchWords} {...rest} />
}

export default Highlighter


// WEBPACK FOOTER //
// ./src/app/components/normal/HighLighter.js